export default __webpack_public_path__ + "static/media/uvnitr.d9597038.png";